import { render, staticRenderFns } from "./home_project4.vue?vue&type=template&id=55aabcf8&scoped=true&"
import script from "./home_project4.vue?vue&type=script&lang=js&"
export * from "./home_project4.vue?vue&type=script&lang=js&"
import style0 from "./home_project4.vue?vue&type=style&index=0&id=55aabcf8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55aabcf8",
  null
  
)

export default component.exports